import Video, { ConnectOptions, LocalTrack } from 'twilio-video';
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { Callback } from '../../../../../models/Types';

import { RootReducer, StreamingReducer } from '../../../../../models/Redux';

// @ts-ignore
window.TwilioVideo = Video;

export default function useRoom(localTracks: LocalTrack[], onError: Callback, options?: ConnectOptions) {
    const {
        localStreamingState: { room },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);
    const [isConnecting] = useState(false);
    const optionsRef = useRef(options);

    useEffect(() => {
        // This allows the connect function to always access the most recent version of the options object. This allows us to
        // reliably use the connect function at any time.
        optionsRef.current = options;
    }, [options]);

    return { room, isConnecting };
}
